module.exports = __webpack_public_path__ + "static/img/echart2.e0bc5820.png";